// components/Card.js
import React, { useState, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

const Card = ({ show }) => {
  const [showScroll, setShowScroll] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    if (show) {
      // Show scroll indicator 5 seconds after the button appears
      const timer = setTimeout(() => setShowScroll(true), 5000);

      // Add scroll listener to detect when user starts scrolling
      const handleScroll = () => {
        if (window.scrollY > 0) {
          setHasScrolled(true);
          setShowScroll(false);
        }
      };

      window.addEventListener('scroll', handleScroll);
      
      return () => {
        clearTimeout(timer);
        window.removeEventListener('scroll', handleScroll);
      };
    } else {
      setShowScroll(false);
      setHasScrolled(false);
    }
  }, [show]);

  return (
    <div className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2
      w-[90vw] md:w-[600px] transition-all duration-1000 z-10
      ${show ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
      <div
        className="w-full bg-white rounded-2xl px-6 md:px-10 py-6 text-gray-800
          shadow-[0_10px_20px_rgba(0,0,0,0.15)] backdrop-blur-sm bg-opacity-95
          transform transition-all duration-300"
      >
        <div className="flex flex-col items-center gap-4">
          <h2 className="text-xl md:text-2xl font-bold text-red-600 mb-2">
          🎄♥God jul Alma♥🎄
          </h2>
          
          <p className="text-base md:text-lg text-center leading-relaxed">
            Etter å ha fått verdens fineste julekalender, tenkte jeg nå å gi deg 
            24 av de utallige grunnene til at jeg elsker deg
          </p>
          
          <div className="text-2xl md:text-3xl text-red-500 mt-2">
          ♥
          </div>
        </div>
      </div>

      {/* Scroll Indicator - only show if user hasn't scrolled yet */}
      <div className={`relative -translate-x-1/2 bottom-[-50px] 
        flex flex-col items-center text-white animate-bounce
        transition-all duration-500
        ${showScroll && !hasScrolled ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}
        `}>
        <p className="text-sm mb-2 text-center">Scroll ned for å se alle</p>
        <ChevronDown size={24} className="animate-pulse" />
      </div>
    </div>
  );
};

export default Card;